const BASE_PATH = "/user";

const routes = {
  root: BASE_PATH,
  profile: `${BASE_PATH}/profile`,
};
export default routes;
